import fp from 'lodash/fp';

import { createSelector } from 'reselect';
import { mappings } from './mappings';

export const combinedColumnsSelector = createSelector(
    state => state.impactAnalysis.impactSummary.columns,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);

export const getRows = state => (
    state.impactAnalysis.impactSummary.impactSummaryRows
);

export const getLoading = state => (
    state.impactAnalysis.impactSummary.loading
);

export const getColumns = state => (
    state.impactAnalysis.impactSummary.columns
);

export const getEodDate = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};

export const getCurrencyToShow = state => (
    state.impactAnalysis.summary.currencyToShow
);

export const getActiveCsa = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'csa');
        const filterValue = fp.get('value')(filter);
        if (filterValue) {
            if (filter.value.length > 0) {
                return filter.value[0];
            }
        }
        return '';
    }
    return '';
};

export const getTrades = state => (
    state.impactAnalysis.tradePricedToday.trades
);

export const getOriginalTrades = state => (
    state.impactAnalysis.tradePricedToday.originalTradesSelection
);

export const getInitialised = state => (
    state.impactAnalysis.impactSummary.initialised
);

export const getSavedFilters = state => (
    state.impactAnalysis.impactSummary.savedFilters
);

export const getShowAllRows = state => (
    state.impactAnalysis.impactSummary.showAllRows
);

export const getRowsToExpand = state => (
    state.impactAnalysis.impactSummary.expandRows
);
